
import uuid from "../../../helpers/guid";

//Função para edição de textos selecionados
export const selectStyle = ({ tag, type, value, cancelValue, rangeSelection, setRangeSelection }) => {
    const selectedText = window.getSelection();
    if (selectedText.toString().trim() !== '' || rangeSelection) {
        //pegando o range da seleção do texto e criando o novo node
        const range = rangeSelection ? rangeSelection.range : selectedText.getRangeAt(0);
        const newNode = document.createElement(tag);

        //Salvando o id do elemento para checagens de elementos vazios
        newNode.id = uuid();
        const element = { id: newNode.id, tag }
        if (
            (selectedText.anchorNode.parentElement && selectedText.anchorNode.parentElement.style[type] === value && selectedText.anchorNode.parentElement.textContent === selectedText)
            || (rangeSelection && rangeSelection.node && rangeSelection.node.style[type] === value && rangeSelection.nodeContent === rangeSelection.selectionText)
        ) {
            if (type && cancelValue) {
                if (rangeSelection.node) {
                    rangeSelection.node.style[type] = cancelValue;
                } else {
                    selectedText.anchorNode.parentElement.style[type] = cancelValue;
                }
            }
            resetSelection(range, selectedText, selectedText.anchorNode.parentElement, setRangeSelection);
        }
        else if (
            (selectedText.anchorNode.parentElement && !!selectedText.anchorNode.parentElement.id && selectedText.anchorNode.parentElement.tagName == tag && selectedText.anchorNode.parentElement.textContent === selectedText)
            || (rangeSelection && rangeSelection.node && !!rangeSelection.node.id && rangeSelection.node.tagName == tag && rangeSelection.node.id != "main" && rangeSelection.nodeContent === rangeSelection.selectionText)
        ) {

            if (type && value) {
                if (rangeSelection.node) {
                    const elemento = document.getElementById(rangeSelection.node.id);
                    elemento.style[type] = value;
                } else {
                    selectedText.anchorNode.parentElement.style[type] = value;
                }
            }

            resetSelection(range, selectedText, selectedText.anchorNode.parentElement, setRangeSelection);
        } else {
            if (type && value)
                newNode.style[type] = value;

            newNode.textContent = rangeSelection ? rangeSelection.selectionText : selectedText;

            //Remove o conteudo da seleção e insere o novo conteudo
            range.deleteContents();
            range.insertNode(newNode);

            resetSelection(range, selectedText, newNode, setRangeSelection);
        }
        return element;
    }
    return null;
}

export const resetSelection = (range, selectedText, node, setRangeSelection = () => { }) => {
    // Move o cursor para o final do novo texto
    range.setStartAfter(node);
    range.setEndAfter(node);
    selectedText.removeAllRanges();
    selectedText.addRange(range);
    setRangeSelection(null);
}